module.exports = __webpack_public_path__ + "9d5a98e4f8ac5fd3b8b551b0bdfc47c2.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/chloe/continue_playing.png
// module id = 128
// module chunks = 0